<div class="custom-select form-field pb-0 mb-0" [class.open]="isOpen">
  <!-- Label -->
  @if(label) {
  <label class="form-field__label" [id]="labelId" (click)="focusTrigger($event)">
    {{ label }}
    @if(required) {
    <span class="form-field__required">*</span>
    }
  </label>
  }
  <!-- Select box -->
  <div
    #trigger
    class="form-field__select form-field__select--{{ size }}"
    [ngClass]="{
      'form-field__select--invalid': control?.touched && control?.invalid,
      'form-field__select--disabled': control?.disabled || disabled
    }"
    (click)="toggleDropdown($event)"
    [title]="title"
    [attr.id]="triggerId"
    role="combobox"
    [attr.aria-expanded]="isOpen"
    [attr.aria-controls]="listboxId"
    [attr.aria-labelledby]="label ? labelId : null"
    [attr.aria-activedescendant]="activeDescendantId"
    [attr.aria-disabled]="control?.disabled || disabled"
    [attr.tabindex]="(control?.disabled || disabled) ? -1 : 0"
    (mousedown)="onTriggerPointerDown()"
    (focus)="onTriggerFocus()"
    (keydown)="onTriggerKeydown($event)"
  >
    @if(!selectedLabel) {
    <span class="form-field__placeholder">{{ placeholder }}</span>
    } @if(selectedLabel) {
    <span>{{ selectedLabel }}</span>
    }
    <span class="arrow">&#9662;</span>
  </div>

  <!-- Dropdown list -->
  @if(isOpen) {
  <div
    class="form-field__dropdown"
    role="listbox"
    [attr.id]="listboxId"
    tabindex="-1"
    (keydown)="onOptionKeydown($event)"
  >
    @if(showSearch) {
    <div class="p-2">
      <input
        type="text"
        class="form-field__input"
        [(ngModel)]="searchTerm"
        (ngModelChange)="filterOptions()"
        placeholder="Search..."
        (click)="$event.stopPropagation()"
      />
    </div>
    } @for(opt of filteredOptions; track $index) {
    <div
      class="form-field__option"
      [class.selected]="opt.value === value"
      [class.active]="activeIndex === $index"
      [class.form-field__option--disabled]="opt.disabled"
      (click)="selectOption(opt, $event)"
      (mouseenter)="onOptionMouseEnter($index)"
      role="option"
      [attr.aria-selected]="opt.value === value"
      [attr.id]="'opt-' + listboxId + '-' + $index"
    >
      {{ opt.label | titlecase }}
    </div>
    } @if(filteredOptions.length === 0) {
    <div class="form-field__no-results">No results found</div>
    }
  </div>
  }
  <!-- Error -->
</div>
@if(errorMessage) {
<div class="form-field__error">{{ errorMessage }}</div>
}
